import { SpinnerMask } from '@atlassian/amkt-common';
import { HostingTypeToQueryParam } from '@atlassian/mpac-types';
import React, { useState } from 'react';
import { useReviews } from "../../../../../hooks/useReviews";
import Section from "../../../../Section";
import ReviewForm from "../ReviewForm";
import UserReviews from "../UserReviews";
import { ReviewsHeader } from "./ReviewsHeader";

const ReviewsContainer = ({
  hosting,
  mpacBaseUrl,
  appKey
}) => {
  const {
    reviewsData,
    showReviewsLoader
  } = useReviews({
    hosting: HostingTypeToQueryParam[hosting],
    mpacBaseUrl,
    appKey
  });
  const [showReviewForm, setShowReviewForm] = useState(false);

  const onShowReviewForm = () => {
    setShowReviewForm(true);
  };

  if (showReviewsLoader) {
    return /*#__PURE__*/React.createElement(SpinnerMask, {
      active: showReviewsLoader,
      testId: "ReviewsLoaderSpinner"
    });
  }

  if (reviewsData) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(ReviewsHeader, {
      hosting: hosting,
      ratings: reviewsData.ratings,
      isLoggedIn: true,
      handleShowReviewForm: onShowReviewForm
    })), showReviewForm && /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(ReviewForm, null)), /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(UserReviews, {
      reviews: reviewsData.reviews
    })));
  }

  return null;
};

export default ReviewsContainer;